import React, {useCallback} from 'react';
import {observer} from 'mobx-react';
import cx from 'classnames';
import {selectAll, setSearch} from '../actions/edi';
import {CheckBox, Flex, PriorityIcon, Select, Text} from '@priority-software/priority-style-react';
import {EdiStore} from '../store/edi';
import {getLocalizedText, texts} from '../../../constants/TextConst';
import style from '../styles/edi.module.scss';

const Header = observer(() => {
    const counterText = getLocalizedText(texts.EDISelected)?.replace(
        'XXX',
        EdiStore.selected.length
    );

    return (
        <Flex>
            <CheckBox
                componentClasses={cx(style.selectHeader, 'text-caption-1')}
                disabled={!EdiStore.hasList}
                checked={EdiStore.isAllSelected}
                onChange={() => selectAll(!EdiStore.isAllSelected)}
            >
                {getLocalizedText(texts.EDISelectAll)}
            </CheckBox>
            <Text skin={'caption-1'}>{counterText}</Text>
        </Flex>
    );
});

export const DialogSelect = observer(() => {
    const onChooseHandler = (options, item) => {
        if (item?.action === 'select-option') {
            item.option.isSelected = true;
        } else if (item?.action === 'deselect-option') {
            item.option.isSelected = false;
        }
    };

    const inputChangeHandler = useCallback((value, actionObj) => {
        const {action} = actionObj;
        if (action !== 'input-blur' && action !== 'menu-close' && action !== 'set-value') {
            setSearch(value);
        }
    }, []);

    const renderItem = useCallback(data => {
        return (
            <CheckBox ariaLabel={data.label} checked={data.isSelected} tabIndex={-1}>
                {data.label}
            </CheckBox>
        );
    }, []);

    const {list, selected, searchValue, companies} = EdiStore;
    return (
        <Select
            size="large"
            shadow={false}
            staticList
            openMenuOnFocus
            isSearchClearable
            onInputClear={() => setSearch('')}
            inputValue={searchValue}
            onInputChange={inputChangeHandler}
            onChange={onChooseHandler}
            hideSelectControl={companies.length < 10}
            isSearchable
            indicatorIcon={PriorityIcon.searchThin}
            controlShouldRenderValue={false}
            filterOption={null}
            autoFocus
            menuScrollMaxHeight={230}
            menuScrollMinHeight={230}
            placeholder={getLocalizedText(texts.EDISearch)}
            tabSelectsValue={false}
            noOptionsMessage={() => getLocalizedText(texts.EDINoResults)}
            options={list}
            value={selected}
            isMulti
            renderItem={renderItem}
            header={() => <Header />}
        />
    );
});
